import { Button, Stack } from '@mui/material';
import { EditRounded, DeleteOutlineOutlined } from '@mui/icons-material';
import { ReactElement } from 'react';

interface AdminControlsProps {
	remove?: () => void;
	edit?: () => void;
}

const AdminControls = ({ remove, edit }: AdminControlsProps): ReactElement => (
	<Stack direction="row" spacing={1.5}>
		{remove && (
			<Button
				variant="outlined"
				color="error"
				startIcon={<DeleteOutlineOutlined />}
				onClick={remove}
			>
				Remove
			</Button>
		)}
		{edit && (
			<Button variant="outlined" startIcon={<EditRounded />} onClick={edit}>
				Edit
			</Button>
		)}
	</Stack>
);

export default AdminControls;
